<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    absolute
    :width="!drawer ? '0' : 'auto'"
    height="700"
    >

    <!-- Selections Header -->
    <v-toolbar dark dense flat :color="toolbarColor">
      <v-img :src="logoUrl" max-width="60" class="pl-0 mr-2"></v-img>
      <v-toolbar-title :class="!isSmallDevice ? 'body-1' : 'body-2'">
        {{ `${activeBreed} Selections` }}
      </v-toolbar-title>
    </v-toolbar>

    <template v-if="selections.length === 0">
    <v-toolbar dense class="elevation-2">
      <v-toolbar-title class="caption">Order has not been set.</v-toolbar-title>
    </v-toolbar>
    </template>

    <template v-else>
      <!-- Next Selection Number -->
      <v-toolbar dense class="elevation-1">
        <template v-if="nextSelectionNum !== null">
          <v-chip dark :color="badgeSelectionNumColor" outlined>{{ nextSelectionNum }}</v-chip>
        </template>
        <!-- Next Selection Name -->
        <template v-if="nextSelectionName !== null">
          <v-chip dark class="ml-6" :color="chipSelectionNameColor" :outlined="!isUserSelection">
            <span class="caption">{{ nextSelectionName }}</span>
          </v-chip>
        </template>
      </v-toolbar>

      <!-- Selections List -->
      <v-container :style="{ maxHeight: '600px' }" class="overflow-y-auto pa-0 ma-0">
        <v-list dense class="py-0">
          <v-list-item v-for="sel in selections" :key="sel.selectionNum">
            <v-list-item-icon :class="getSelectionNumClass(sel.accountNo)">{{ sel.selectionNum }}</v-list-item-icon>
            <v-list-item-title :class="getSelectionContactClass(sel.accountNo)">{{ sel.contactName }}</v-list-item-title>
            <v-list-item-action>
              <template v-if="sel.calfSn">
                <v-icon small :color="appColor_Selected" class="my-0 pa=0">
                  check_circle
                </v-icon>
              </template>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { AppColor } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BbSelectionsDrawer',
  props: {
    selections: {
      type: Array,
      default: null
    },
    activeBreed: {
      type: String,
      default: null
    },
    animalSource: {
      type: Object,
      default: null
    },
    selectionsDrawer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,
      appColor_Selected: AppColor.Selected,

      drawer: this.selectionsDrawer
    }
  },
  computed: {
    ...mapGetters(['profile', 'currentBullSale']),
    beefboosterAccountNo () {
      if (this.isNullOrUndefined(this.profile)) return null
      if (this.isNullOrUndefined(this.profile.bbCustomerStatus)) return null
      return this.profile.isBeefboosterCustomer && this.profile.bbCustomerStatus.isValid
        ? this.profile.bbCustomerStatus.accountNo
        : null
    },
    logoUrl () {
      return !this.isNullOrUndefined(this.currentBullSale.animalSource)
        ? this.currentBullSale.animalSource.logoUrl
        : ''
    },
    nextSelection () {
      const available = this.selections.filter(s => { return s.calfSn === null })
      return available.length > 0
        ? available[0]
        : null
    },
    nextSelectionNum () {
      return this.nextSelection !== null
        ? this.nextSelection.selectionNum
        : null
    },
    nextSelectionName () {
      return this.nextSelection !== null
        ? this.nextSelection.contactName
        : 'Selections Complete'
    },
    nextSelectionAccountNo () {
      return this.nextSelection !== null
        ? this.nextSelection.accountNo
        : null
    },
    chipSelectionNameColor () {
      return !this.isUserSelection
        ? 'blue-grey darken-2'
        : 'indigo' 
    },
    isUserSelection () {
      return this.beefboosterAccountNo === this.nextSelectionAccountNo
    },
    badgeSelectionNumColor () {
      return !this.isUserSelection
        ? 'blue-grey darken-2'
        : 'blue-grey darken-3'
    },
    toolbarColor () {
      if (this.isNullOrUndefined(this.animalSource)) return 'blue-grey darken-2'
      return `${this.animalSource.colourCode} darken-2`
    },
    isSmallDevice () {
      return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
    }
  },
  methods: {
    getSelectionNumClass (accountNo) {
      return this.beefboosterAccountNo === accountNo
        ? 'caption font-weight-black mr-1 py-0'
        : 'caption font-weight-regular mr-1 py-0'
    },

    getSelectionContactClass (accountNo) {
      return this.beefboosterAccountNo === accountNo
        ? 'body-2 font-weight-black'
        : 'caption font-weight-regular'
    },

    isNullOrUndefined (obj) {
      return obj === undefined 
        || typeof obj === 'undefined' 
        || obj === null
    }
  },
  watch: {
    selectionsDrawer (value) {
      if (value === null) return

      // set locally if true
      if (!value) return
      this.drawer = value
    },
    drawer (value) {
      if (value === null) return

      // return if false
      if (value) return
      this.$emit('close')
    }
  }
}
</script>